import styled from 'styled-components'

/* Fundo branco só na área da direita (dentro do RightSide) */
export const FullPageWrapper = styled.div`
  background-color: #ffffff;
  color: #1a1a1a;
  font-family: 'Roboto', system-ui, sans-serif;

  /* ocupa SEMPRE a tela toda */
  position: fixed;
  inset: 0;             /* top:0; right:0; bottom:0; left:0 */

  display: flex;
  align-items: center; 
  justify-content: center; 
  text-align: center;
`


/* Caixinha central, igual o card do login antigo */
export const Box = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Logo = styled.img`
  max-height: 40px;
  width: auto;
  margin-bottom: 24px;
`

export const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.3;
  margin: 0 0 12px 0;
`

export const Subtitle = styled.p`
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6b6b6b;
  margin: 0 0 24px 0;
  max-width: 380px;
`

export const FormGroup = styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 16px;
`

export const FieldLabel = styled.label`
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 6px;
`

export const InputField = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 24px;
  border: 1px solid #cfcfcf;
  background-color: #efefef;
  padding: 0 14px;
  font-size: 0.9rem;
  color: #1a1a1a;

  &::placeholder {
    color: #9b9b9b;
  }
`

export const SubmitButton = styled.button`
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 24px;
  background-color: #007dc9;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 16px;
  margin-bottom: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(0.95);
  }

  &:active {
    filter: brightness(0.9);
  }
`

export const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #0072ce;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const BackIcon = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`

export const BackText = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`
